export enum FTNAV_EVENT {
  OPENED = "ftnav.global-navigation.opened",
  CLOSE = "ftnav.global-navigation.close",
  REGISTER_SLIDER = "ftnav.slider.register",
  REGISTERED_SLIDER = "ftnav.slider.registered",
}
